import { render, staticRenderFns } from "./TipsAndPrivewDilog.vue?vue&type=template&id=640ed4be&scoped=true&"
import script from "./TipsAndPrivewDilog.vue?vue&type=script&lang=js&"
export * from "./TipsAndPrivewDilog.vue?vue&type=script&lang=js&"
import style0 from "./TipsAndPrivewDilog.vue?vue&type=style&index=0&id=640ed4be&prod&lang=scss&scoped=true&"
import style1 from "./TipsAndPrivewDilog.vue?vue&type=style&index=1&id=640ed4be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ed4be",
  null
  
)

export default component.exports